import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { emit, list, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<section class="slex-accordion-item"><h3 class="slex-accordion-heading"><button type="button" class="slex-accordion-trigger"><span class="slex-accordion-label"><!> <span> </span></span> <span class="slex-accordion-indicator" aria-hidden="true"></span></button></h3> <div class="slex-accordion-content"><div class="slex-accordion-content-inner"> </div></div></section>`);
var root_1 = $.from_html(`<div class="slex-accordion" data-scope="accordion"><div class="slex-accordion-inner"></div></div>`);

export default function Accordion($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));
	let value = $.state(undefined);
	let openStates = $.state($.proxy({}));
	const items = $.derived(() => list($.get(p).items));

	function keyFor(item) {
		return text(item.value ?? item.label);
	}

	function valueForKey(key) {
		const item = $.get(items).find((entry) => keyFor(entry) === key);

		return item ? item.value ?? item.label : undefined;
	}

	function selectedKeys(nextValue, multiple) {
		if (multiple && Array.isArray(nextValue)) return nextValue.map((entry) => text(entry));

		const selected = text(nextValue);

		return selected ? [selected] : [];
	}

	function openValue(states = $.get(openStates)) {
		const keys = Object.keys(states).filter((key) => states[key]);

		if ($.get(p).multiple) return keys.map((key) => valueForKey(key)).filter((entry) => entry !== undefined);

		return keys.length ? valueForKey(keys[0]) : undefined;
	}

	$.user_effect(() => bindPropStore($$props.props, (next) => {
		$.set(p, next, true);
		$.set(value, next.value, true);

		const selected = selectedKeys(next.value, next.multiple === true);
		const nextOpenStates = {};

		for (const item of list(next.items)) {
			const key = keyFor(item);

			nextOpenStates[key] = selected.includes(key);
		}

		$.set(openStates, nextOpenStates, true);
	}));

	function toggleItem(key) {
		const open = !!$.get(openStates)[key];
		let nextStates;

		if ($.get(p).multiple) {
			nextStates = { ...$.get(openStates), [key]: !open };
		} else {
			nextStates = {};

			for (const item of $.get(items)) nextStates[keyFor(item)] = false;

			nextStates[key] = !open;
		}

		$.set(openStates, nextStates, true);

		const nextValue = openValue(nextStates);

		$.set(value, nextValue, true);
		emit($$props.ctx, "change", nextValue);
	}

	var div = root_1();
	var div_1 = $.child(div);

	$.each(div_1, 21, () => $.get(items), $.index, ($$anchor, item) => {
		const key = $.derived(() => keyFor($.get(item)));
		const open = $.derived(() => !!$.get(openStates)[$.get(key)]);
		var section = root();
		var h3 = $.child(section);
		var button = $.child(h3);
		var span = $.child(button);
		var node = $.child(span);

		{
			var consequent = ($$anchor) => {
				InlineIcon($$anchor, {
					get name() {
						return $.get(item).icon;
					},

					get selected() {
						return $.get(open);
					},
					className: 'slex-accordion-icon'
				});
			};

			$.if(node, ($$render) => {
				if ($.get(item).icon) $$render(consequent);
			});
		}

		var span_1 = $.sibling(node, 2);
		var text_1 = $.child(span_1, true);

		$.reset(span_1);
		$.reset(span);
		$.next(2);
		$.reset(button);
		$.reset(h3);

		var div_2 = $.sibling(h3, 2);
		var div_3 = $.child(div_2);
		var text_2 = $.child(div_3, true);

		$.reset(div_3);
		$.reset(div_2);
		$.reset(section);

		$.template_effect(
			($0, $1) => {
				$.set_attribute(section, 'data-state', $.get(open) ? "open" : "closed");
				$.set_attribute(button, 'data-state', $.get(open) ? "open" : "closed");
				$.set_attribute(button, 'aria-expanded', $.get(open));
				$.set_attribute(button, 'aria-controls', `${$$props.ctx.id}-${$.get(key)}-content`);
				button.disabled = $.get(item).disabled === true;
				$.set_text(text_1, $0);
				$.set_attribute(div_2, 'id', `${$$props.ctx.id}-${$.get(key)}-content`);
				$.set_attribute(div_2, 'data-state', $.get(open) ? "open" : "closed");
				$.set_attribute(div_2, 'aria-hidden', !$.get(open));
				$.set_text(text_2, $1);
			},
			[
				() => text($.get(item).label),
				() => text($.get(item).content)
			]
		);

		$.delegated('click', button, () => toggleItem($.get(key)));
		$.append($$anchor, section);
	});

	$.reset(div_1);
	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);